export default {
   'features': 'Fonctionnalités',
   'downloads': 'Téléchargements',
   'roadmap': 'Feuille de route',
   'price': 'Prix',
   'donate': 'Donner',
   'feedback': 'Retours',
   'panel': 'Panneau de contrôle',
};
